import React, { useEffect, useState } from 'react'
import './App.scss'
import Portal from './Portal'
import {
  Button,
  CourseSearchForm,
  CourseSectionView,
  CourseView,
  CurrentCampusView,
  HomeCampusSessionForm,
  InstructorSearchForm,
  InstructorView,
  MenuCampusSessionForm,
  ProgramStudiesTable,
  ProgramStudyTimetablesTable,
  ProgramStudyView,
  SubjectCoursesTable,
  SubjectsTable,
  WeeklyTimeTable,
} from './components'
import { useI18n } from '@ggs/i18n'
import { get } from 'lodash'

/**
 * React application components initialization.
 * @return {JSX.Element}
 */
function App() {
  const { changeLanguage } = useI18n()
  const [languageReady, setLanguageReady] = useState(false)
  const languageCode = get(window || {}, `drupalSettings.path.currentLanguage`, 'en')

  useEffect(() => {
    changeLanguage(languageCode)
    setLanguageReady(true)
    console.log('SetDrupalLanguage:', languageCode)
  }, [languageCode])

  // Wait that language resolution is done before rendering components.
  if (!languageReady) {
    return null
  }

  return (
    <div className="App">
      <Portal containerId='react-button'>
        <Button>Test Button</Button>
      </Portal>
      <Portal containerId='subject-courses-table'>
        <SubjectCoursesTable />
      </Portal>
      <Portal containerId='subjects-table'>
        <SubjectsTable />
      </Portal>
      <Portal containerId='home-campus-session-form'>
        <HomeCampusSessionForm />
      </Portal>
      <Portal containerId='menu-campus-session-form'>
        <MenuCampusSessionForm />
      </Portal>
      <Portal containerId='course-view'>
        <CourseView />
      </Portal>
      <Portal containerId='course-section-view'>
        <CourseSectionView />
      </Portal>
      <Portal containerId='course-search'>
        <CourseSearchForm />
      </Portal>
      <Portal containerId='instructor-search'>
        <InstructorSearchForm />
      </Portal>
      <Portal containerId='instructor-view'>
        <InstructorView />
      </Portal>
      <Portal containerId='current-campus-view'>
        <CurrentCampusView />
      </Portal>
      <Portal containerId='weekly-time-table'>
        <WeeklyTimeTable />
      </Portal>
      <Portal containerId='program-studies-table'>
        <ProgramStudiesTable />
      </Portal>
      <Portal containerId='program-study-timetables-table'>
        <ProgramStudyTimetablesTable />
      </Portal>
      <Portal containerId='program-study-view'>
        <ProgramStudyView />
      </Portal>
    </div>
  )
}

export default App
